import invariant from 'fbjs/lib/invariant';

export default loadConfig;

/**
 *
 * @param {string} pUrl
 * @param {string} pToken
 * @return {Promise<Config|ConfigRequestError>}
 */
function loadConfig (pUrl, pToken) {
  invariant(pUrl, 'Missing required argument: config URL');
  invariant(pToken, 'Missing required argument: bearer token');

  return fetch(pUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${pToken}`,
      'Content-type': 'application/json',
    }
  })
    .then((response) => {
      if (response.ok) {
        return response;
      }
      throw new ConfigRequestError('response is not ok', `http:${response.status}`);
    }, (reason) => {
      throw new ConfigRequestError(reason.message, "reqErr");
    })
    .then((response) => {
      const clone = response.clone();
      return response.json()
        .catch(createVerboseJSONError(clone));
    })
    .then((payload) => {
      if (payload.result === 'error') {
        throw new ConfigRequestError(`error in response: ${payload.message}`, payload.code);
      }

      return payload.data;
    });
}

function createVerboseJSONError (clone) {
  return () => {
    return clone.text().then(text => {
      throw new ConfigRequestError(text.slice(0, 100), 'unexpected-json');
    });
  };
}

// ConfigRequestError.prototype = Object.create(Error.prototype, { constructor: ConfigRequestError });

/**
 *
 * @param {string} message
 * @param {string|number} code
 * @return {Error}
 * @constructor
 */
function ConfigRequestError (message, code = 'UNKNOWN') {
  const error = new Error('Config request failure. ' + message);
  error.name = 'ConfigRequestError';
  error.code = `config.${code}`;
  error.fatal = true;
  return error;
}
